import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';

import contentStyle from '@/src/cms/contentStyle';
import Head from '@/src/shared/components/Head';
import Hero from '@/src/shared/components/Hero';
import Sanitize from '@/src/shared/components/Sanitize';

const styles = {
  heroContainer: css`
    @media print {
      -webkit-print-color-adjust: exact !important; /* Chrome, Safari */
      color-adjust: exact !important;
    }
  `,
  body: [
    contentStyle,
    css`
      div {
        max-width: none !important;
        margin: 0 auto;
      }
    `,
  ],
};

const HeroContent = ({ heroData, children }) => (
  <>
    <Head title={heroData.MetaTitle} description={heroData.MetaDescription} />
    <Hero
      css={styles.heroContainer}
      title={heroData.HeroHeadline}
      type={heroData.HeroImageId ? 'image' : 'default'}
      bgImage={`${process.env.NEW_API_URL}image/file?area=c&id=${heroData.HeroImageId}`}
    >
      <div css={styles.body}>
        <Sanitize allowedSchemes={['http', 'https', 'mailto']}>
          {heroData.HeroParagraph}
        </Sanitize>
        {children}
      </div>
    </Hero>
  </>
);

HeroContent.propTypes = {
  heroData: PropTypes.object.isRequired,
};

export default HeroContent;

